import LeadingLinks from '../../components/leading-links';
import AsideNavLink from '../../components/aside-nav-link';
import AsideLayout from '../../components/layouts/aside-layout';
import MainLayout from '../../components/layouts/main-layout';
import Timeline from '../../components/timeline';
import HeroImage from '../../public/img/hero/history_1920_640.jpg';
import Head from 'next/head';

export default function History(props) {
    return (
        <MainLayout>
            <Head>
                <title>History | Solvar</title>
                <meta name="description" content="Solvar company history."></meta>
            </Head>
            <AsideLayout
                prev={
                    <LeadingLinks href="/about-us/company-overview" prev>Company Overview</LeadingLinks>
                }
                next={
                    <LeadingLinks href="/about-us/board-of-directors" next>Board of Directors</LeadingLinks>
                }
                heroImage={ HeroImage }
                location={
                    <p className="capitalize text-bb">
                        <span className="font-bold">About Us</span> › History
                    </p>
                }
                aside={
                    <>
                        <h6 className="text-h3 text-bb pb-20">About Us</h6>
                        <AsideNavLink href="/about-us/company-overview">Company Overview</AsideNavLink>
                        <AsideNavLink href="/about-us/history" active={true}>History</AsideNavLink>
                        <AsideNavLink href="/about-us/board-of-directors">Board of Directors</AsideNavLink>
                        <AsideNavLink href="/about-us/management-team">Management Team</AsideNavLink>
                        <AsideNavLink href="/about-us/corporate-governance">Corporate Governance</AsideNavLink>
                        <AsideNavLink href="/about-us/philanthropy">Philanthropy</AsideNavLink>
                        <AsideNavLink href="/about-us/sustainability">Sustainability</AsideNavLink>
                        <h6 className="text-h3 text-bb pb-20 pt-40">Investors</h6>
                        <AsideNavLink href="/investors/shareholder-information">Shareholder Information</AsideNavLink>
                        <AsideNavLink href="/investors/company-announcements">Company Announcements</AsideNavLink>
                        <AsideNavLink href="/investors/annual-reports">Annual Reports</AsideNavLink>
                        <h6 className="text-h3 text-bb pb-20 pt-40">Contact</h6>
                        <AsideNavLink href="/contact/contact-us">Contact Us</AsideNavLink>
                    </>
                }
            >
                <h1 className="text-bb pb-40">History</h1>
                <div className="sol-markdown-content">
                    <p>Since 2000 we've been helping our customers achieve their dreams with finance for their vehicles and personal needs.</p>
                </div>
                <Timeline
                    items={
                        [
                            {
                                date: '2025',
                                content: (
                                    <>
                                        <p>In January 2025, the debt facility in New Zealand for Go Car Finance was fully repaid with the remaining portfolio funded by equity.</p>
                                        <p>In March 2025, Solvar executed an Asset Backed Securitisation. This deal was Money3's first term securitisation, providing additional funding capacity by transferring $199.85m of Money3's existing assets to a new securitisation trust, structured as a private debt placement, with an initial $139.4m in external debt funding at a lower cost, amortising over the term. The transaction was funded by private credit funds managed by global alternative asset manager and supported by a leading financial services group, demonstrating the Company's capital management strategy of building a scalable and sustainable funding model to support the future growth strategy.</p>
                                        <p>In June 2025, the AFS business unit improved repricing of the existing variable rate revolving debt facility and resized it to $285.0m limit (from $237.5m) which is subject to a one-year funding availability period, with the ability to extend.</p>
                                        <p>In November 2025, the M3 business unit improved repricing of the existing variable rate revolving debt facility, resized to $270.0m limit (from $510.0m) with the flexibility to expand funding limits when required. In addition, a new competitively priced variable rate revolving debt facility with a $488.0m limit was secured with a major foreign financial institution in Australia and a leading global financial services group. Both of these facilities are subject to a two-year funding availability period, with the ability to extend.</p>
                                        <p>In New Zealand operations, the Group has repaid and cancelled the debt facility, with the remaining book funded by equity. On 25 November 2025 Solvar announced the sale of its New Zealand arrears loan book which had been sold for NZ$8.0m, accelerating our exit from the New Zealand market. Payment was received in December 2025.</p>
                                    </>
                                )
                            },
                            {
                                date: '2024',
                                content: (
                                    <>
                                        <p>In February 2024, Solvar refinanced the previous debt facilities for Money3 with a new $450m warehouse funding facility with a leading global financial services group.</p>
                                        <p>In September 2024, a mezzanine investor was brought into this revolving facility with a $60m limit, funded by private credit funds managed by global alternative asset manager and supported by a leading financial services group.</p>
                                    </>
                                )
                            },
                            {
                                date: '2022',
                                content: (
                                    <p>Money3 Corporation Limited (the parent company) changed its name to Solvar Limited.</p>
                                )
                            },
                            {
                                date: '2021',
                                content: (
                                    <>
                                        <p>Money3 entered the near-prime automotive market via the acquisition of Automotive Financial Services (AFS) and Holden Financial Services (GMFA) legacy loan book.</p>
                                        <p>45.1% increase in loan book to $637.5m as at 30 June.</p>
                                    </>
                                )
                            },
                            {
                                date: '2020',
                                content: (
                                    <>
                                        <p>Established of a warehouse securitisation facility with a consortium of major banks to fuel loan book growth towards $1bn</p>
                                        <p>Company raised $50m via an equity placement to institutional investors and Share Purchase Plan to shareholders</p>
                                        <p>Gross loan book grew to $433.8m</p>
                                    </>
                                )
                            },
                            {
                                date: '2019',
                                content: (
                                    <>
                                        <p>Money3 exited SACC lending.  Sale of all SACC lending brands inclusive of Cash Train, First Stop Money, Handy Cash and Money3 Branches</p>
                                        <p>Expanded into New Zealand market with the acquisition of Go Car Finance (NZ) 48% growth in gross loan book </p>
                                        <p>25% growth in revenue </p>
                                        <p>1 in 500 registered vehicles in Australia had a loan with Money3</p>
                                        <p>1 in 800 registered vehicles in New Zealand had a loan with Go Car Finance.</p>
                                    </>
                                )
                            },
                            {
                                date: '2018',
                                content: (
                                    <>
                                        <p>Gross loan book grew to $308.1m</p>
                                        <p>Group NPAT increased 10.1% over prior period</p>
                                        <p>In excess of $1bn of loans originated for consumers</p>
                                        <p>Entered the ASX300</p>
                                    </>
                                )
                            },
                            {
                                date: '2017',
                                content: (
                                    <p>Establishment of a new secured funding facility with Fortress Investment Group to underpin loan book growth</p>
                                )
                            },
                            {
                                date: '2016',
                                content: (
                                    <p>Gross loan book grew to $198.8m</p>
                                )
                            },
                            {
                                date: '2015',
                                content: (
                                    <>
                                        <p>Scott Baldwin was appointed as Chief Executive Officer</p>
                                        <p>Announced the transition out of some small amount credit contract products</p>
                                    </>
                                )
                            },
                            {
                                date: '2014',
                                content: (
                                    <>
                                        <p>Acquisition of Paid International, which includes brands Cash Train, First Stop Money and Handy Cash</p>
                                        <p>Gross loan book grew to $22.4m</p>
                                    </>
                                )
                            },
                            {
                                date: '2013',
                                content: (
                                    <>
                                        <p>Money3 Head Office and Secured Loan Centre relocated to Bundoora, Melbourne</p>
                                        <p>Acquired 41 Cash Store businesses and outstanding loan book of Assistive Finance Australia</p>
                                        <p>Gross loan book grew to $10.6m</p>
                                    </>
                                )
                            },
                            {
                                date: '2011',
                                content: (
                                    <p>Acquisition of Tasmanian credit provider Personal Finance Co.</p>
                                )
                            },
                            {
                                date: '2010',
                                content: (
                                    <p>Launched of Auto Loans Product</p>
                                )
                            },
                            {
                                date: '2009',
                                content: (
                                    <p>Launched of Online Loans</p>
                                )
                            },
                            {
                                date: '2007',
                                content: (
                                    <p>Established Money3 Secured Loan Centre to execute broker referrals</p>
                                )
                            },
                            {
                                date: '2006',
                                content: (
                                    <p>Money3 Corporation Limited was listed on the ASX</p>
                                )
                            },
                            {
                                date: '2005',
                                content: (
                                    <p>Changed trading name to “Money3 Corporation Limited”</p>
                                )
                            },
                            {
                                date: '2003',
                                content: (
                                    <>
                                        <p>Loan book funding increased via debt and equity placement.</p>
                                        <p>Opened three new locations.</p>
                                    </>
                                )
                            },
                            {
                                date: '2001',
                                content: (
                                    <p>Commenced trading as “Money Plus”.</p>
                                )
                            },
                        ]
                    }
                />
            </AsideLayout>
        </MainLayout>
    );
}